import { useNavigate } from "react-router-dom";

function NotAuthorized() {
  const navigate = useNavigate();

  return (
    <div className="container mt-5 text-center">
      <div style={{ fontSize: "5rem" }}>🚫</div>
      <h2 className="mt-3">Accès non autorisé</h2>
      <p className="text-muted">
        Vous n'avez pas les permissions pour accéder à cette page.
      </p>
      <button
        className="btn btn-primary mt-2"
        onClick={() => navigate("/")}
      >
        Retour à l'accueil
      </button>
    </div>
  );
}

export default NotAuthorized;